import Block from './Block'
import Splide from '@splidejs/splide'
import gsap from 'gsap'
import store from '../util/store'

export default class ModularBanner extends Block {
  getElems() {
    this.hasCarousel = Boolean(this.el.querySelector('.b-modular-banner__carousel'))
    if (this.hasCarousel) {
      this.thumbnails = this.el.querySelector('.splide.--thumbnails')
      this.sliderThumbnails = null
      this.slides = this.el.querySelector('.splide.--slides')
      this.sliderSlides = null
      this.nav = {
        prev: this.el.querySelector('.splide__chevron.--up'),
        next: this.el.querySelector('.splide__chevron.--down')
      }
    }
    this.shape = this.el.querySelector('.b-modular-banner__shape')
    this.scrollButton = this.el.querySelector('.e-button.--scroll')
    this.lenis = store.smoothScroll
  }

  init() {
    if (this.hasCarousel) {
      this.sliderThumbnails = new Splide(this.thumbnails, {
        height: '15.6vw',
        width: '5.3vw',
        autoHeight: true,
        autoWidth: true,
        direction: 'ttb',
        gap: 12,
        pagination: false,
        perPage: 4,
        isNavigation: true,
        type: 'loop',
        autoplay: true
      })

      this.sliderSlides = new Splide(this.slides, {
        height: window.innerWidth < 1024 ? '100%' : '39.55vw',
        pagination: false,
        arrows: false,
        direction: 'ttb',
        autoHeight: true,
        autoWidth: true,
        perPage: 1,
        type: 'loop',
        lazyLoad: false
      })

      this.sliderSlides.sync(this.sliderThumbnails)
      this.sliderSlides.mount()
      this.sliderThumbnails.mount()
    }

    this._shapeParallax()
  }

  _shapeParallax() {
    if (this.shape) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          start: 'center center',
          end: 'bottom top',
          scrub: true
        }
      })

      tl.fromTo(this.shape, {
        yPercent: -2
      }, {
        yPercent: 5
      })
    }
  }

  events() {
    if (this.nav) {
      this.nav.prev.addEventListener('click', () => {
        this.sliderThumbnails.go('<')
      })

      this.nav.next.addEventListener('click', () => {
        this.sliderThumbnails.go('>')
      })
    }

    if (this.scrollButton) {
      this.scrollButton.addEventListener('click', () => {
        const nextSection = this.el.nextElementSibling

        if (nextSection) {
          this.lenis.scrollTo(nextSection, {
            offset: 100,
            duration: 2,
            easing: (t) => 1 - Math.pow(1 - t, 3)
          })
        }
      })
    }
  }
}
